import { Row } from '@/app/components/Flex/Flex'
import { Link } from '@/app/components/Link/Link'
import { Text, type TextTag } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import classNames from 'classnames'
import type { ComponentChild, FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const CalendarCard: FunctionalComponent<{
  as?: TextTag
  date?: string
  title: ComponentChild
  subTitle?: ComponentChild
  text: string
  link?: string
}> = props => {
  return (
    <UI.Panel
      shadow
      type='user'
      class={styles.panel}
    >
      <Row gap={8}>
        {props.date && (
          <Text
            upper
            fontSize={12}
            fontWeight={500}
            opacity={0.5}
            lineHeight={1}
          >
            {props.date}
          </Text>
        )}

        <Row gap={6}>
          <Row gap={8}>
            <Text
              as={props.as ?? 'h2'}
              fontSize={20}
              fontWeight={600}
              lineHeight={1}
            >
              {props.title}
            </Text>

            {props.subTitle && (
              <Text
                fontSize={14}
                lineHeight={1.3}
                class={styles.subTitle}
              >
                {props.subTitle}
              </Text>
            )}
          </Row>

          <Row gap={5} alignItems='flex-start'>
            {props.text && (
              <Text
                as='p'
                fontSize={16}
              >
                {props.text}
              </Text>
            )}

            {props.link && (
              <Link to={props.link} class={classNames('color-link', styles.link)}>
                Подробнее →
              </Link>
            )}
          </Row>
        </Row>
      </Row>
    </UI.Panel>
  )
}
